import { TRPCError } from "@trpc/server";
import { AppError } from "server/types/errors";

export * as Sentry from "@sentry/nextjs";

/**
 * Determines if an error should be captured by Sentry.
 */
export function shouldCaptureError(error: unknown): boolean {
  if (error instanceof TRPCError) {
    if (error.code !== "INTERNAL_SERVER_ERROR") {
      return false;
    }

    // If the error _is_ a TRPCError with code "INTERNAL_SERVER_ERROR",
    // the cause will have the info we want.
    if (error.cause) error = error.cause;
  }

  if (error instanceof AppError) {
    return error.status >= 500;
  }

  return true;
}
